import { apiCall, createQueryString } from "../imports"

const PREFIX = "notification/sms-logs"

export default {

    getSmsLogs(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },
    retrySmsLog(id) {
        return apiCall('post', `${PREFIX}/${id}/retry`);
    }
    
}